module.exports = __webpack_public_path__ + "static/details-4-17c59f77b632ece5b9022b3bc6f23037.jpg";